import React from 'react';

const StayInformed = () => {
  return (
        <div id="Features" className="section grey-section">
            <div className="container _6em">
            <div className="center-text">
                <div className="fade-in-move-on-scroll">
                <h1>Stay Informed and Prepared, Wherever You Are with TrenziX</h1>
                </div>
                <div className="paragraph-hero">
                <div className="fade-in-move-on-scroll">
                    <p>TrenziX redefines mobility in forex analysis, offering you a rich suite of analytical tools right on your mobile device. TrenziX ensures you&#x27;re equipped with the latest market insights and trend predictions to inform your trades elsewhere. Perfect for traders who need a reliable source of forex intelligence on the move, our app is your companion for making strategic trading decisions with confidence.</p>
                </div>
                </div>
            </div>
            <div className="sticky-slider-section">
                <div className="w-layout-grid sticky-slider-container">
                <div className="sticky-text-container">
                    <div className="sticky-text-holder">
                    <div className="fade-in-move-on-scroll">
                        <h2 className="no-margins">Your Market Data, Tailored for On-The-Go Analysis</h2>
                    </div>
                    <div className="fade-in-move-on-scroll">
                        <p>TrenziX brings the pulse of the forex market to your fingertips. Designed with simplicity in mind, our app lets you scroll through the latest market data, analyze trends, and keep abreast of changes effortlessly. With just a few swipes, stay updated and make informed decisions no matter where you are</p>
                    </div>
                    <div className="list-container">
                        <ul className="w-list-unstyled">
                        <li>
                            <div className="list-holder">
                            <div className="list-icon-container"><img src="/assets/images/Checkmark-Icon.png" loading="lazy" alt="" className="_100width"/></div>
                            <div>Easy to use and understand</div>
                            </div>
                        </li>
                        <li>
                            <div className="list-holder">
                            <div className="list-icon-container"><img src="/assets/images/Checkmark-Icon.png" loading="lazy" alt="" className="_100width"/></div>
                            <div>Accessible from anywhere</div>
                            </div>
                        </li>
                        <li>
                            <div className="list-holder">
                            <div className="list-icon-container"><img src="/assets/images/Checkmark-Icon.png" loading="lazy" alt="" className="_100width"/></div>
                            <div>Always connected, ensuring you have real-time market insights on the fly.</div>
                            </div>
                        </li>
                        </ul>
                    </div>
                    </div>
                </div>
                <div className="slider-image-holder">
                    <div className="slider-sticky-holder _03"><img src="/assets/images/3D_Image_3.png" loading="lazy" alt="" className="feature-image"/></div>
                </div>
                </div>
            </div>
            </div>
        </div>
    );
};


export default StayInformed;